module.exports = __webpack_public_path__ + "static/b1-fcf6cf9dc09cd622bc4c24d449a77588.png";